// ---------------------------------------------------------------------------
// PWA_ControlBillet — Statistics card component
// Displays a label, large value, optional color and icon.
// ---------------------------------------------------------------------------

import type { ReactNode } from 'react';

interface Props {
  label: string;
  value: number | string;
  color?: string;
  icon?: ReactNode;
}

export function StatCard({ label, value, color, icon }: Props) {
  // Default text color to accent-light if no color is provided.
  const valueColor = color ?? 'text-accent-light';

  return (
    <div className="bg-surface-card rounded-2xl p-4 flex flex-col items-center justify-center min-h-[120px] transition-transform duration-150 active:scale-[0.97]">
      {/* Icon */}
      {icon && (
        <div className="mb-2 opacity-80">{icon}</div>
      )}

      {/* Value */}
      <p className={`text-3xl font-bold ${valueColor}`}>{value}</p>

      {/* Label */}
      <p className="text-gray-400 text-xs font-medium mt-1 text-center">
        {label}
      </p>
    </div>
  );
}
